import { motion } from "framer-motion";
import * as PhosphorIcons from "@phosphor-icons/react";
import { OPPORTUNITY_CATEGORIES } from "../lib/constants";
import { ArrowUpRight } from "@phosphor-icons/react";

export const OpportunityExchange = () => {
  return (
    <section
      id="opportunities"
      data-testid="opportunities-section"
      className="relative py-24 md:py-32 bg-[#050B14]"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid lg:grid-cols-12 gap-12 mb-16">
          <div className="lg:col-span-7">
            <div className="flex items-center gap-3 mb-6">
              <span className="text-xs tracking-[0.3em] uppercase text-[#D1B677] font-medium">
                Business Opportunity Exchange
              </span>
            </div>
            <h2 className="font-serif text-white text-3xl sm:text-4xl lg:text-5xl tracking-tight leading-[1.1]">
              Twelve sectors.{" "}
              <span className="italic text-[#D1B677]">One coastal gateway.</span>
            </h2>
          </div>
          <div className="lg:col-span-5 lg:pt-4">
            <p className="text-[#A1AEBF] text-base leading-relaxed max-w-md">
              Structured categories curated for serious investors and globally-minded
              Goa-based ventures. Every category is screened, classified, and
              opportunity-ready.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 border-l border-t border-white/8">
          {OPPORTUNITY_CATEGORIES.map((c, i) => {
            const Icon = PhosphorIcons[c.icon] || PhosphorIcons.Sparkle;
            return (
              <motion.a
                key={c.key}
                href="#register"
                initial={{ opacity: 0 }}
                whileInView={{ opacity: 1 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: i * 0.04 }}
                data-testid={`opp-card-${c.key}`}
                className="group relative p-10 border-r border-b border-white/8 hover:bg-[#0C5A48]/10 hover:border-[#D1B677]/30 transition-all duration-500 cursor-pointer overflow-hidden"
              >
                <div className="absolute top-6 right-6 opacity-0 group-hover:opacity-100 transition-opacity duration-500">
                  <ArrowUpRight size={20} weight="light" className="text-[#D1B677]" />
                </div>
                <div className="flex items-center justify-between mb-12">
                  <span className="font-serif italic text-sm text-[#A1AEBF]/40">
                    /{c.number}
                  </span>
                  <Icon
                    size={32}
                    weight="light"
                    className="text-[#D1B677]/80 group-hover:text-[#D1B677] group-hover:scale-110 transition-all duration-500"
                  />
                </div>
                <h3 className="font-serif text-white text-xl lg:text-2xl leading-tight mb-2 group-hover:text-[#D1B677] transition-colors duration-500">
                  {c.title}
                </h3>
                <span className="text-xs tracking-[0.2em] uppercase text-[#A1AEBF]/60">
                  Opportunities Available
                </span>
              </motion.a>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default OpportunityExchange;
